// ✅ useFetchSamples.js 

import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchSamples = (collectionId, apiUrl) => {
  const [samples, setSamples] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSamples = async () => {
      if (!collectionId) {
        console.log("No collectionId provided");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const endpoint = `${apiUrl}/voice-collections/samples/by-collection/${collectionId}`;
        console.log("Fetching samples from:", endpoint);

        const response = await axios.get(endpoint);
        const allSamples = response.data.data || [];

        const activeSamples = allSamples.filter(sample => sample.visibility?.isActive === true);
        console.log("Active samples:", activeSamples.length);

        setSamples(activeSamples);
      } catch (err) {
        console.error("❌ Error fetching samples:", err);
        setError(err.message || "Error retrieving samples.");
      } finally {
        setLoading(false);
      }
    };

    fetchSamples();
  }, [collectionId, apiUrl]);

  return { samples, loading, error };
};

export default useFetchSamples;